import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Loading = (props: object) => (
  <FontAwesomeIcon icon={faCircleNotch} spin {...props} />
)

export default Loading
